import React from 'react';
import './PrintableOrder.css';

import logo from '../../assets/fp-logo.png';

import {
  useLocation,
  useNavigate
} from 'react-router-dom';

import {
  LuArrowLeft,
  LuPrinter,
  LuPhone,
  LuCarFront,
  LuClipboardList
} from 'react-icons/lu';

const PrintableOrder = () => {

  const navigate = useNavigate();

  const { state } = useLocation();

  const order = state?.order;

  const first_name = localStorage.getItem('fpfirstName');
  const last_name = localStorage.getItem('fplastName');

  if (!order) {
    return (
      <div className="po-empty">
        <h2>Ordem não encontrada</h2>

        <button onClick={() => navigate('/orders')}>
          Voltar
        </button>
      </div>
    );
  }

  const totalServicos =
    order.serviceDescription?.reduce((acc, cur) => {
      return acc + parseFloat(cur.valor || 0);
    }, 0) || 0;

  const handlePrint = () => {
    window.print();
  };

  return (

    <div className="po-page">

      {/* ACTIONS */}

      <div className="po-actions no-print">

        <button
          className="po-action-btn po-back-btn"
          onClick={() => navigate('/orders')}
        >
          <LuArrowLeft size={18} />
          Voltar
        </button>

        <button
          className="po-action-btn po-print-btn"
          onClick={handlePrint}
        >
          <LuPrinter size={18} />
          Imprimir Ordem
        </button>

      </div>

      {/* PAPER */}

      <div className="po-paper">

        {/* HEADER */}

        <header className="po-header">

          <div className="po-company">

            <img
              src={logo}
              alt="FP Motorhome"
              className="po-logo"
            />

            <div>

              <h1>FP Motorhome</h1>

              <p>
                Especializada em manutenção e personalização
              </p>

            </div>

          </div>

          <div className="po-order-box">

            <span>ORDEM DE SERVIÇO</span>

            <strong>
              #{order.order_number + 1025}
            </strong>

          </div>

        </header>

        {/* COMPANY INFOS */}

        <section className="po-company-infos">

          <div>
            <span>Endereço</span>
            <p>Av. Zeferino Costa, 3148</p>
          </div>

          <div>
            <span>Cidade</span>
            <p>Pelotas • RS</p>
          </div>

          <div>
            <span>Telefone</span>
            <p>(53) 99172-6266</p>
          </div>

          <div>
            <span>Data</span>
            <p>
              {new Date().toLocaleDateString('pt-BR')}
            </p>
          </div>

        </section>

        {/* CLIENT */}

        <section className="po-card">

          <div className="po-card-title">

            <LuPhone size={16} />

            <h3>Dados do Cliente</h3>

          </div>

          <div className="po-grid po-grid-2">

            <div>
              <span>Cliente</span>
              <p>{order.cliente}</p>
            </div>

            <div>
              <span>Telefone</span>
              <p>{order.phone || 'Não informado'}</p>
            </div>

          </div>

        </section>

        {/* VEHICLE */}

        <section className="po-card">

          <div className="po-card-title">

            <LuCarFront size={16} />

            <h3>Dados do Veículo</h3>

          </div>

          <div className="po-grid po-grid-4">

            <div>
              <span>Placa</span>
              <p>{order.plate}</p>
            </div>

            <div>
              <span>Marca</span>
              <p>{order.brand}</p>
            </div>

            <div>
              <span>Modelo</span>
              <p>{order.model}</p>
            </div>

            <div>
              <span>Ano</span>
              <p>{order.year}</p>
            </div>

          </div>

          {!!order.vehicleDescription && (

            <div className="po-description">

              <span>Descrição</span>

              <p>
                {order.vehicleDescription}
              </p>

            </div>

          )}

        </section>

        {/* SERVICES */}

        <section className="po-card">

          <div className="po-card-title">

            <LuClipboardList size={16} />

            <h3>Serviços Executados</h3>

          </div>

          <table className="po-table">

            <thead>

              <tr>
                <th>#</th>
                <th>Serviço</th>
                <th>Valor</th>
              </tr>

            </thead>

            <tbody>

              {order.serviceDescription?.map((service, index) => (

                <tr key={index}>

                  <td>
                    {index + 1}
                  </td>

                  <td>

                    <div className="po-service-name">
                      {service.Service}
                    </div>

                    {!!service.OBS && (
                      <div className="po-service-obs">
                        {service.OBS}
                      </div>
                    )}

                  </td>

                  <td>
                    R$ {parseFloat(service.valor || 0).toFixed(2)}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

          <div className="po-total">

            <span>Total</span>

            <strong>
              R$ {totalServicos.toFixed(2)}
            </strong>

          </div>

        </section>

        {/* SIGNATURES */}

        <footer className="po-footer">

          <div className="po-signatures">

            <div className="po-signature">

              <div className="po-sign-line" />

              <strong>
                {`${first_name || ''} ${last_name || ''}`}
              </strong>

              <span>Técnico Responsável</span>

            </div>

            <div className="po-signature">

              <div className="po-sign-line" />

              <strong>{order.cliente}</strong>

              <span>Cliente</span>

            </div>

          </div>

        </footer>

      </div>

    </div>

  );
};

export default PrintableOrder;